import { OnItemImpressionType } from '@utils/useTrackImpression';
import { Heading } from 'app/components/Recommendations/Recommendations.styles';
import { ContentItemFragment } from 'app/graphql/__generated__/types/contento.js';
import React from 'react';
import ShowcaseCard from '../ShowcaseCard/ShowcaseCard';
import { GridContainer, StyledShowcase } from './Showcase.styles';

export type Props = {
    items: Array<ContentItemFragment>;
    onItemClick: (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        itemPosition: number,
        svtId: string,
        autoPlay?: boolean,
        b?: boolean
    ) => void;
    onItemImpression?: OnItemImpressionType;
    className?: string;
    addBottomMargin?: boolean;
    header?: string;
    isDisplaywindow?: boolean;
};

const Showcase = ({
    items,
    onItemClick,
    onItemImpression,
    className,
    addBottomMargin = false,
    header = '',
    isDisplaywindow,
}: Props): JSX.Element => (
    <StyledShowcase
        className={className}
        data-helix-type={isDisplaywindow ? 'no-track' : 'list'}
        aria-label={!isDisplaywindow ? header || 'Rekommenderat' : ''}
        addBottomMargin={addBottomMargin}
    >
        {!isDisplaywindow && <Heading as="h2">{header}</Heading>}
        <GridContainer>
            {items.map((item, index) => (
                <ShowcaseCard
                    key={index}
                    item={item}
                    index={index}
                    onItemClick={onItemClick}
                    onItemImpression={onItemImpression}
                />
            ))}
        </GridContainer>
    </StyledShowcase>
);

export default Showcase;
